import React from "react";
import {
	Container,
	Header,
	GoBack,
	Title,
	Lead,
	Layout,
	LeftContent,
	RightContent,
	Content2,
} from "./styles";
import { useOperationalDashboardViewModel } from "./useOperationalDashboardViewModel";
import { ReactComponent as ArrowBack } from "../../assets/kinologyIcons/svg/arrow-left.svg";
import MetricsHeader from "./components/MetricsHeader";
import QuickActions from "./components/QuickActions";
import TodayAgenda from "./components/TodayAgenda";
import AICopilotSection from "./components/AICopilotSection";
import TodayFocus from "./components/TodayFocus";
import ReadyForReevaluationModal from "./components/ReadyForReevaluationModal";
import CriticalAlertModal from "./components/CriticalAlertModal";
import RecentEvaluationsModal from "./components/RecentEvaluationsModal";
import PatientListSelectionModal from "./components/PatientListSelectionModal";
import PatientSelectionForCopilotModal from "./components/PatientSelectionForCopilotModal";
import DetailedRecordModal from "./components/DetailedRecordModal";

const OperationalDashboard: React.FC = () => {
	const {
		navigateHome,
		metrics,
		isLoadingResumo,
		resumoError,
		retryResumo,
		handleMetricClick,
		isReevaluationModalOpen,
		isCriticalAlertModalOpen,
		isRecentEvaluationsModalOpen,
		setIsRecentEvaluationsModalOpen,
		isPatientListModalOpen,
		setIsPatientListModalOpen,
		handleOpenPatientListModal,
		isCopilotPatientModalOpen,
		setIsCopilotPatientModalOpen,
		copilotPatient,
		setCopilotPatient,
		copilotSummarySnapshot,
		handleCopilotSummaryStateChange,
		handleRefreshLatestCopilotPatient,
		isDetailedRecordModalOpen,
		setIsDetailedRecordModalOpen,
		todayFocusContactTarget,
		handleOpenTodayFocusContact,
		handleTodayFocusContactStarted,
		closeReevaluationModal,
		closeCriticalAlertModal,
	} = useOperationalDashboardViewModel();

	return (
		<Container>
			<Content2>
				<Header>
					<GoBack onClick={navigateHome} aria-label="Voltar para Início">
						<ArrowBack />
						Início
					</GoBack>
					<Title>Painel Operacional</Title>
					<Lead>Sua rotina clínica centralizada, sem retrabalho manual.</Lead>
				</Header>
				<MetricsHeader
					metrics={metrics}
					isLoading={isLoadingResumo}
					error={resumoError}
					onRetry={retryResumo}
					onMetricClick={handleMetricClick}
				/>
				<Layout>
					<LeftContent>
						<AICopilotSection
							patient={copilotPatient}
							initialLoading={isLoadingResumo}
							initialError={resumoError}
							onRetryInitial={retryResumo}
							onSelectPatientClick={() => setIsCopilotPatientModalOpen(true)}
							onOpenRecord={() => setIsDetailedRecordModalOpen(true)}
							onSummaryStateChange={handleCopilotSummaryStateChange}
							onRefreshLatestPatient={handleRefreshLatestCopilotPatient}
						/>
						<TodayFocus onOpenContact={handleOpenTodayFocusContact} />
					</LeftContent>
					<RightContent>
						<QuickActions openPatientListModal={handleOpenPatientListModal} />
						<TodayAgenda />
					</RightContent>
				</Layout>
			</Content2>
			<ReadyForReevaluationModal
				isOpen={isReevaluationModalOpen}
				onClose={closeReevaluationModal}
				initialPatient={
					todayFocusContactTarget?.queueKey === "convidarReavaliacao"
						? todayFocusContactTarget.item
						: null
				}
				onContactStarted={handleTodayFocusContactStarted}
			/>
			<CriticalAlertModal
				isOpen={isCriticalAlertModalOpen}
				onClose={closeCriticalAlertModal}
				initialPatient={
					todayFocusContactTarget?.queueKey === "resgatarCliente"
						? todayFocusContactTarget.item
						: null
				}
				onContactStarted={handleTodayFocusContactStarted}
			/>
			<RecentEvaluationsModal
				isOpen={isRecentEvaluationsModalOpen}
				onClose={() => setIsRecentEvaluationsModalOpen(false)}
			/>
			<PatientListSelectionModal
				isOpen={isPatientListModalOpen}
				onClose={() => setIsPatientListModalOpen(false)}
			/>
			<PatientSelectionForCopilotModal
				isOpen={isCopilotPatientModalOpen}
				onClose={() => setIsCopilotPatientModalOpen(false)}
				onSelectPatient={setCopilotPatient}
			/>
			<DetailedRecordModal
				isOpen={isDetailedRecordModalOpen}
				onClose={() => setIsDetailedRecordModalOpen(false)}
				patient={copilotPatient}
				copilotSummary={copilotSummarySnapshot}
			/>
		</Container>
	);
};

export default OperationalDashboard;
